import * as React from "react";
import { useMemo } from "react";
import { Field } from "formik";
import styled from "styled-components";
import { Input } from "components/bootstrap";
import { Select } from "components/common";
import { defaultCompare } from "logic/DefaultCompare";
import { useIsAllowedToFetchAssets } from "security-app/hooks/useAssetsAPI";
const FieldContainer = styled.div`
  flex-basis: 100%;
`;
const AssetsFilterFieldValue = ({ fieldName, assetLabels }) => {
  const isAllowedToFetchAssets = useIsAllowedToFetchAssets();
  const assetsOptions = useMemo(
    () => assetLabels == null ? void 0 : assetLabels.sort((s1, s2) => defaultCompare(s1.name, s2.name)).map(({ id, name }) => ({
      value: id,
      label: name
    })),
    [assetLabels]
  );
  return /* @__PURE__ */ React.createElement(Field, { name: fieldName, required: true }, ({ field: { name, value, onChange }, meta: { error } }) => /* @__PURE__ */ React.createElement(FieldContainer, null, /* @__PURE__ */ React.createElement(Input, { error, name, formGroupClassName: "", id: name }, /* @__PURE__ */ React.createElement(
    Select,
    {
      options: assetsOptions != null ? assetsOptions : [],
      value: Array.isArray(value) ? value == null ? void 0 : value.join(",") : value,
      displayKey: "key",
      multi: true,
      inputId: name,
      onChange: (newVal) => {
        onChange({ target: { value: newVal == null ? void 0 : newVal.split(","), name } });
      },
      placeholder: "Assets",
      allowCreate: !isAllowedToFetchAssets
    }
  ))));
};
export default AssetsFilterFieldValue;
